export default "__VITE_ASSET__DcEZVzGk__"